import {
  IAdhocNotification,
  IAdhocNotificationSaveRequest,
} from '../business-objects/common';
import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';
import * as actionTypes from '../redux-objects/actionTypes';
import {
  NotificationTemplateInfo,
  NotificationsInfo,
} from '../../MultiSelect/common';

export const saveAdhocNotification = (
  url: string,
  notification: IAdhocNotificationSaveRequest,
  onSave: () => void
) => {
  return async (dispatch) => {
    try {
      await Api.post(url, notification).then((res: ApiResponse<any>) => {
        onSave();
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const getNotificationOptions = (requestURL: string) => {
  return async (dispatch) => {
    await Api.get(requestURL)
      .then((res: ApiResponse<any>) => {
        dispatch(loadNotificationOptionsIntoStore(res.data));
        return Promise.resolve(res.data);
      })
      .catch((error) => {
        console.error(error);
        return Promise.reject(error);
      });
  };
};

export const cacheAdhocNotification = (notification: IAdhocNotification) => {
  return {
    type: actionTypes.CACHE_NOTIFICATION,
    value: notification,
  };
};

export const loadNotificationOptionsIntoStore = (notificationOptions: any) => {
  return {
    type: actionTypes.GET_ALL_ACTIVE_NOTIFICATION_TEMPLATES_INTO_STORE,
    value: notificationOptions.notifications,
  };
};
